import { render, staticRenderFns } from "./Sucursales_agregar.vue?vue&type=template&id=48fde732"
import script from "./Sucursales_agregar.vue?vue&type=script&lang=js"
export * from "./Sucursales_agregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports